import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Box, Link, Stack, Avatar, Drawer, Typography, CardActionArea } from '@material-ui/core';
import { useSelector } from 'react-redux';
// hooks
import useCollapseDrawer from './context/useCollapseDrawer';
// components

import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import { MHidden } from '../../components/@material-extend';
import sidebarConfig from './SidebarConfig';
import CareLogo from '../../assets/img/logo.svg';
import ProfileImg from '../../assets/img/avatar_default.jpg';
import { BACKEND } from '../../services/api.path';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.complex
    })
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[500_12]
}));

const CollpaseIcon = styled('button')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  outline: 0,
  margin: 0,
  cursor: 'pointer',
  verticalAlign: 'middle',
  appearance: 'none',
  textDecoration: 'none',
  textAlign: 'center',
  flex: '0 0 auto',
  borderRadius: '50%',
  overflow: 'visible',
  // color: rgb(99, 115, 129);
  // transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  // font-size: 1.125rem;
  padding: 4,
  top: 32,
  position: 'fixed',
  left: 265,
  zIndex: 1101,
  border: '1px dashed rgba(145, 158, 171, 0.24)',
  backdropFilter: 'blur(6px)',
  backgroundColor: 'rgba(255, 255, 255, 0.48)'
}));

// ----------------------------------------------------------------------

IconCollapse.propTypes = {
  onToggleCollapse: PropTypes.func,
  collapseClick: PropTypes.bool
};

function IconCollapse({ onToggleCollapse, collapseClick }) {
  return (
    <CollpaseIcon
      sx={{
        left: collapseClick ? COLLAPSE_WIDTH - 12 : DRAWER_WIDTH - 12
      }}
    >
      <CardActionArea
        sx={{
          width: 18,
          height: 18,
          display: 'flex',
          cursor: 'pointer',
          borderRadius: '50%',
          alignItems: 'center',
          color: 'text.primary',
          justifyContent: 'center'
        }}
      >
        <Icon
          icon={collapseClick ? 'material-symbols:arrow-forward-ios-rounded' : 'material-symbols:arrow-back-ios-new'}
          width={16}
          height={16}
          color="grey"
          onClick={onToggleCollapse}
        />
      </CardActionArea>
    </CollpaseIcon>
  );
}

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const { profile } = useSelector((state) => state.auth);
  const { isCollapse, collapseClick, collapseHover, onToggleCollapse } = useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <>
      <MHidden width="lgDown">
        <IconCollapse onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />
      </MHidden>
      <Scrollbar
        sx={{
          height: '100%',
          '& .simplebar-content': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <Stack
          spacing={3}
          sx={{
            px: 2.5,
            pt: 3,
            pb: 2,
            ...(isCollapse && {
              alignItems: 'center'
            })
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box component={RouterLink} to="/" sx={{ display: 'inline-flex' }}>
              {/* <Logo /> */}
              <img src={CareLogo} style={isCollapse ? {} : { width: '50%' }} alt="" />
            </Box>

            {/* <MHidden width="lgDown">
              {!isCollapse && <IconCollapse onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />}
            </MHidden> */}
          </Stack>

          {isCollapse ? (
            <Avatar alt="My Avatar" src={BACKEND + profile?.image || ProfileImg} sx={{ mx: 'auto', mb: 2 }} />
          ) : (
            <Link underline="none" component={RouterLink} to="/dashboard/profile  ">
              <AccountStyle>
                <Avatar alt="My Avatar" src={BACKEND + profile?.image || ProfileImg} />
                <Box sx={{ ml: 2 }}>
                  <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                    {profile?.fullName || 'Admin WSES'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Admin
                  </Typography>
                </Box>
              </AccountStyle>
            </Link>
          )}
        </Stack>

        <NavSection navConfig={sidebarConfig} isShow={!isCollapse} />
      </Scrollbar>
    </>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? COLLAPSE_WIDTH : DRAWER_WIDTH
        },
        ...(collapseClick && {
          position: 'absolute'
        })
      }}
    >
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          // onMouseEnter={onHoverEnter}
          // onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              ...(isCollapse && {
                width: COLLAPSE_WIDTH
              }),
              ...(collapseHover && {
                borderRight: 0,
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
                boxShadow: (theme) => theme.customShadows.z20,
                bgcolor: (theme) => alpha(theme.palette.background.default, 0.88)
              })
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
